import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { JobTitle } from '../../../models'

export const MB_JOB_TITLE_NORMALIZER = new InjectionToken<Converter<any, JobTitle[]>>('MbJobTitleNormalizer')
